module.exports = __webpack_public_path__ + "static/media/ETANG-EQ-PATIO.bc5563d8.webp";